import { render } from "./DocumentClassAttributesForm.vue?vue&type=template&id=3b45e940&scoped=true&ts=true"
import script from "./DocumentClassAttributesForm.vue?vue&type=script&lang=ts"
export * from "./DocumentClassAttributesForm.vue?vue&type=script&lang=ts"

import "./DocumentClassAttributesForm.vue?vue&type=style&index=0&id=3b45e940&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b45e940"]])

export default __exports__